var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"send-flex-card"},[(_vm.isSending)?_c('toast-alert',{attrs:{"isLoading":_vm.isLoading,"text":"แชร์สำเร็จ"}}):_vm._e(),_vm._t("button")],2)}
var staticRenderFns = []

export { render, staticRenderFns }